












































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CompanyDto from "@/models/Companies/CompanyDto";
import { CompanyDetailsModule } from "@/store/modules/companyDetails";
import UpdateCompanyProfileDetailsRequest from "@/models/Companies/UpdateCompanyProfileDetailsRequest";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";

@Component({
  name: "CompanyProfileDetailsEdit",
})
export default class extends GiganautVueDialog {

  public entity = new CompanyDto();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(CompanyDetailsModule.currentCompany));
    }
  }

  get loading() {
    return CompanyDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateCompanyProfileDetailsRequest();
    request.updatedAt = CompanyDetailsModule.currentCompany.updatedAt;
    request.brandName = this.entity.brandName;
    //request.biography = this.entity.biography;
    request.website = this.entity.website;
    await CompanyDetailsModule.editCompanyProfileDetails(request);
    this.dialog = false;
  }
}
